import { IProduktdefinition } from "./IProduktdefinition";
import { ProduktdefinitionMatrisdata } from "./ProduktdefinitionMatrisdata";

export class ProduktdefinitionFargmarkningdata {
    constructor(readonly matrisdata: ProduktdefinitionMatrisdata) {
    }

    mapToDto(model: IProduktdefinition) {
        // Mappning till dto
    }
}
